import PatientView from './PatientView';
export default PatientView;